//Core modules
import React, {Fragment, useEffect, useState} from "react";

//External modules
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import {Col, Row} from "react-bootstrap";
import Select from "react-select";
import { useForm, Controller } from "react-hook-form";
import {faCircleInfo, faCopy} from "@fortawesome/free-solid-svg-icons";
import {CopyToClipboard} from "react-copy-to-clipboard";
import cx from "classnames";
import {Button,Label,Input,FormText} from "reactstrap";
import {faPlus} from "@fortawesome/free-solid-svg-icons";
import {faXmark} from "@fortawesome/free-solid-svg-icons/faXmark";
import Switch from "react-switch";

//Internal modules
import requestApi from "../services/requestApi.service"
import { getSessionValue,
    handleErrorResponse,
    parseJSON,
    populateCurrentFormDetail, showToast,getServerDomainURL, getPickLists,getPickListItems, 
    confirmBoxWithImage} from "./Appcommon";
import CratioTooltip from "./CratioTooltip";


function FieldsMapping ({formInfo, onBackAction,screen,mappingCol,leadstatus,provider,formfildefault,webhookurl,formFilterOptions,webhookNameVal}) {

    const [currentMappings, setCurrentMappings] = useState([]);
    const [mappingInfo, setMappingInfo] = useState([]);
    const [fieldsOptions, setFieldOptions] = useState([]);
    const [googleAdsFieldOptions, setGoogleAdsFieldOptions] = useState([]);
    const [fieldsobject, setFieldObject] = useState({});
    const [mappingIds,setMappingIds] = useState([]);
    const [mappingCount,setMappingCount] = useState(0);
    const [statusText, setstatusText] = useState(leadstatus !== "inactive" ? "active" : leadstatus);
    const [formFilOptions, setFormFilOptions] = useState(formfildefault);
    const [webhookName, setWebhookName] = useState(webhookNameVal);
    const [copied,setCopied] = useState(false);
    const form = useForm();
    const { handleSubmit,control, formState: { errors } } = form;
    const [mandataryFields, setMandataryFields] = useState("");
    const leadFormname = getSessionValue('leadformname');
    const baseUrl = getServerDomainURL();
    const webhookUrl = baseUrl+"/"+webhookurl;
    const [suggestions, setSuggestions] = useState([]);
    const [clickedMapId, setClickedMapId] = useState([]);
    const [pickListItems,setPickListName] = useState([]);
    const [assignTo ,setAssignedTo] = useState("");
    const [mappingneeded,setMappingNeeded] = useState(false);

    let leadFormDetail = [];
    let payload = [];
    let mappingColumns = [];
    let mappingList = [];
    let obj = [];
    obj.push(formInfo[0]);
    if(screen === 'webhooks'){
        obj.push(formInfo[4]);
        obj.push(formInfo[2]);
        obj.push(formInfo[3]);
    }
    useEffect(()=>{
        (async () => {
            await getFieldMappingInfo();
            await processEditInfo();
            await getLeadFieldsInfo();
        })();
    },[formInfo]);

    useEffect(()=>{
        (async () => {
            await processEditInfo();
        })();
    },[currentMappings,fieldsobject]);

    const getFieldMappingInfo = async () => {
        if(formInfo !== undefined && formInfo !== null && formInfo[0] !== undefined){
            let entity = "GOOGLEADSPROCESS";
            if(screen === 'CloudTelephony'){
                entity = "CLOUDTELEPHONYLEADSPROCESS";
            } else if(screen === 'webhooks'){
                entity = "WEBHOOKSLEADSPROCESS";
            }
            let params = {
                "ENTITY" : entity,
                "OPERATION" : 'GET_FIELD_MAPPING',
                "ID" : obj
            }
            let response = await requestApi.processServerRequest(params, "WebV2");
            if(response.issuccess){
                if(screen === 'webhooks' && response.data[0].length == 0){
                    setMappingNeeded(false);
                }else{
                    setMappingNeeded(true);
                }
                if(screen === 'Googleads'){
                    await setCurrentMappings([...response.data]);
                }else{
                    await setCurrentMappings([...response.data[0]]);
                    await setMandataryFields(response.data[1]);
                }
            }else{
                handleErrorResponse(response.errormsg);
            }
        }
    }

    const copyUrl = () => {
        setCopied(true);
    }

    const getLeadFieldsInfo = async (name) => {
        let formnameVal = leadFormname;
        let formname = formInfo[2];
        if(formname ===  "" || formname === undefined){
            formname = "Leads";
        }
        if(name !== undefined){
          formname = name;
        }
        if(screen != 'webhooks'){
            let paramts = {
                "ENTITY" : 'WHATSAPPPROCESS',
                "OPERATION" : 'GETPRODUCTMAPPER',
            }
            let res = await requestApi.processServerRequest(paramts, "WebV2");
            if(res.issuccess){
                if(res.data != ""){
                    formname = res.data;
                }
            }
        }
        let entity = 'GOOGLEADSPROCESS';
        if(screen === 'webhooks'){
            entity = 'WEBHOOKSLEADSPROCESS';
        }
        let params = {
            "ENTITY" : entity,
            "OPERATION" : 'GET_FORMFIELDS',
            "formname" : formname
        }
        let response = await requestApi.processServerRequest(params, "WebV2");
        if(response.issuccess){
            leadFormDetail = response.data;
        }else{
            handleErrorResponse(response.errormsg);
        }
       
        let skipFields = [
            'Lead_ID',
            'wsapp_recent_activity',
            'wsapp_convo_status',
            'wsapp_unread_count',
            'wsapp_optin_status',
            'wsapp_recent_msg_id',
            'wsapp_enabled',
            'wsapp_blocked',
            'wsapp_opt',
            'wsapp_last_delivered',
            'wsapp_last_read',
            'wsapp_last_replied',
            'wsapp_last_sent_msg_id',
            'wsapp_last_sent_msg_id',
            'wsapp_completed_campaign',
            'lead_assigned_at',
            'first_touch_at',
            'call_did_status'
        ];  
        if(leadFormDetail !== undefined ){
            let fieldDetails = leadFormDetail;
            let fields = [];
            let fieldsObj = {};
            fieldDetails && fieldDetails.map((field) => {
                let fieldName = field[0];
                let fieldLabel = field[1];
                let fieldType = field[2];
                let isConfigHide = parseInt(field[3]);
                let isViewHide = parseInt(field[4]);
                let defaultValue = field[5];
                if (!isConfigHide && !isViewHide) {
                    if (fieldType !== 'subtable' && fieldType !== 'reference_entityid' && fieldType !== "reference_group" && fieldType !== "form_history") {
                        if (!skipFields.includes(fieldName)) {
                            if(fieldType === "ComboBox"){  
                                let pickListDetials = defaultValue.split(",");
                                let pickListName = pickListDetials[0]; 
                                    pickListItems.push({value: pickListName, label: fieldLabel});
                            }
                            if (fieldType === "entity_group") {
                                setAssignedTo(fieldLabel);
                            }
                            if(screen === 'webhooks' && fieldType !== 'reference'){
                            /*if (fieldLabel !== undefined && fieldType === "entity_group") {
                                fields.push({
                                    value: fieldLabel, label: fieldLabel
                                })
                                fieldsObj[fieldLabel] = {
                                    value: fieldLabel, label: fieldLabel
                                };
                            } else {*/
                            fields.push({
                                value: fieldName, label: fieldLabel
                            })
                            fieldsObj[fieldName] = {
                                value: fieldName, label: fieldLabel
                            };
                        //}
                            }else{
                            /*if (fieldLabel !== undefined && fieldType === "entity_group") {
                                fields.push({
                                    value: fieldLabel, label: fieldLabel
                                })
                                fieldsObj[fieldLabel] = {
                                    value: fieldLabel, label: fieldLabel
                                };
                            } else {*/
                            fields.push({
                                value: fieldName, label: fieldLabel
                            })
                            fieldsObj[fieldName] = {
                                value: fieldName, label: fieldLabel
                            };
                        //}
                            }
                        }
                    }
                }
                return true;
            });

            await setFieldOptions([...fields]);
            await setFieldObject({...fieldsObj});
            await setPickListName([...pickListItems])
        }
    }
    
    const fetchSuggestions = async (query,mappingInfo,mappingId,pickListItems,assignTo) => { 
            let suggestion = [];
            let label = "";
            for (let i = 0; i < mappingInfo.length; i++) {
                label = mappingInfo[mappingId]['fieldselected']['label'];
                if (query !== "" && label !== undefined) {
                    if (label === assignTo) {
                        let params = {
                            "ENTITY": "CLOUDTELEPHONYLEADSPROCESS",
                            "OPERATION": 'USER_DROP_DOWN',
                        };
                        let response = await requestApi.processServerRequest(params, "WebV2");
                        suggestion = response.data[0];
                    } else {
                        pickListItems.map((item, index) => {
                            if (label === item['label']) {
                                suggestion = getPickListItems(item['value']);
                            }
                        });
                    }
                } else {
                    setSuggestions([]);
                }
            }            
            let  filteredSuggestions= [];      
            for(let i = 0; i < suggestion.length; i++) {
                let data = suggestion[i];
                if (data.toLowerCase().startsWith(query.toLowerCase())) {
                    filteredSuggestions[i] = data;
                }                                     
            }  
            setSuggestions(filteredSuggestions);
    }
    const handleSuggestionClick = (data, name,mappingId) => {
    const suggestionText = data.textContent; 
    mappingInfo[mappingId][name] = suggestionText;
    setSuggestions([]);
    };


    const processEditInfo = async () => {      
        
        let curMappingIds = [];
        let curMappingCount = 0;
        let curGoogleAdsOptions = [];
        let curGoogleAdsFields = [];
        let formvalue = {};
        //Get coloumn details received from googleads.
        if(screen !== 'CloudTelephony' && screen !== 'webhooks'){
            if(formInfo[3] !== undefined && formInfo[3] !== "" && formInfo[3] !== null){
                payload = parseJSON(formInfo[3]);
                if(payload['user_column_data'] !== undefined && payload['user_column_data'] !== "" && payload['user_column_data'] !== null){
                    mappingColumns = payload['user_column_data'];
                }
                if(payload['campaign_id'] !== undefined && payload['campaign_id'] !== "" && payload['campaign_id'] !== null 
                   && payload['adgroup_id'] !== undefined && payload['adgroup_id'] !== "" && payload['adgroup_id'] !== null){
                    const camplabel = 'campaign_id';
                    const campvalue = payload['campaign_id'];
                    const adgrouplabel = 'adgroup_id';
                    const adgroupvalue = payload['adgroup_id'];
                    curGoogleAdsFields[campvalue] = { 'label': camplabel, 'value': campvalue };
                    curGoogleAdsOptions.push({ label: camplabel, value: campvalue });
                    curGoogleAdsFields[adgroupvalue] = { 'label': adgrouplabel, 'value': adgroupvalue };
                    curGoogleAdsOptions.push({ label: adgrouplabel, value: adgroupvalue });
                }
            }
            for(let i=0;i<Object.keys(mappingColumns).length;i++){
                const label = mappingColumns[i][`column_name`] !== undefined ? mappingColumns[i][`column_name`] : mappingColumns[i][`column_id`];
                const value = mappingColumns[i][`column_id`] !== undefined ? mappingColumns[i][`column_id`] : "";
                curGoogleAdsFields[value] = {label,value};
                curGoogleAdsOptions.push({label,value});
            }
        } else if(screen === 'CloudTelephony' || screen === 'webhooks') {
            if(screen === 'webhooks'){
                let params = {
                    "ENTITY": "WEBHOOKSLEADSPROCESS",
                    "OPERATION" : 'GET_PAYLOADFIELDS_MAPPING',
                    "RandomID"  : obj
                }
                let response = await requestApi.processServerRequest(params,"WebV2");
                if(response.issuccess){
                    if(screen === 'webhooks'){
                        mappingCol = response.data;
                    }else{
                        mappingCol = Object.keys(response.data);
                    }
                }else{
                    handleErrorResponse(response.errormsg);
                }
            }
            for(let i=0;i<Object.keys(mappingCol).length;i++){
                const label = mappingCol[i] !== undefined ? mappingCol[i] : "";
                const value = mappingCol[i] !== undefined ? mappingCol[i] : "";
                curGoogleAdsFields[value] = {label,value};
                curGoogleAdsOptions.push({label,value});
            }
        }
        if(currentMappings && currentMappings.length > 0){
            for(let i=0;i<currentMappings.length;i++){

                let googleadsfield = {};
                let label = '';
                
                if(currentMappings[i][1].includes('@') && currentMappings[i][1].length > 1){
                    label = currentMappings[i][1].split('@')[0];
                    if(curGoogleAdsFields[label]){
                        googleadsfield = curGoogleAdsFields[label];
                    }
                }
                const fieldname = currentMappings[i][0] ? currentMappings[i][0] : '';
                const defaultval = currentMappings[i][2] ? currentMappings[i][2] : '';
                formvalue = currentMappings[i][3] ? currentMappings[i][3] : '';
                formvalue = {value: formvalue, label: formvalue};
                const selectedField = fieldsobject[fieldname] ? fieldsobject[fieldname] : {};
                mappingInfo[i] = {
                    googleadsfield : googleadsfield,
                    fieldselected : selectedField,
                    fieldname : fieldname,
                    googleadsvalue : label,
                    defaultvalue : defaultval,
                };

                curMappingIds.push(i);
                curMappingCount++;
            }
        }else{
            curMappingIds.push(0);
            curMappingCount++;
        }
        await setMappingInfo([...mappingInfo]);
        await setGoogleAdsFieldOptions([...curGoogleAdsOptions]);
        await setMappingIds([...curMappingIds]);
        await setMappingCount(curMappingCount);
       // await setFormFilOptions(formvalue);
    }

    const onLeadFieldChange = async (data, name,mappingId) => {
        if(mappingInfo[mappingId] === undefined){
            mappingInfo[mappingId] = {};
        }
        if(name === "defaultvalue"){
            setClickedMapId(mappingId);
        }
        mappingInfo[mappingId][name] = data;
        fetchSuggestions(data,mappingInfo,mappingId,pickListItems,assignTo);
        if(name === "fieldselected" && data !== undefined && data.value !== undefined){
            mappingInfo[mappingId]['fieldname'] = data.value;
            //mappingInfo[mappingId]['defaultvalue'] = "";
        }else if(name === "googleadsfield" && data !== undefined && data.value !== undefined){
            mappingInfo[mappingId]['googleadsvalue'] = data.value;
        }
        await setMappingInfo([...mappingInfo]);
    }

    const onFormnameChange = async (e) => {
         setFormFilOptions(e);
        await getLeadFieldsInfo(e.value);
     }

    const handleWebhookChange = async (e) => {
        setWebhookName(e.target.value);
    }

    const changeLeadStatus = async (title,statusText) => {
        
        let newStatus = statusText === "active" ? "inactive" : "active";
        let toastStatus = statusText === "active" ? "Disabled" : "Enabled";
        let entity = "CLOUDTELEPHONYLEADSPROCESS";
        // if(newStatus == "inactive"){
        //     setstatusText(newStatus);
        // }
       // if(screen === 'webhooks'){
          //  entity = "WEBHOOKSLEADSPROCESS";
         //   provider = formInfo[3];
       // }
        let params = {
            "ENTITY" : entity,
            "OPERATION" : 'UPDATE_LEADCREATION_STATUS',
            "PROVIDER" : provider,
            "LEADSTATUS" : newStatus
        }
        let response = await requestApi.processServerRequest(params);
        if(response.issuccess){
            if(response.data[0] !== undefined){
                let data = JSON.parse(response.data[0]);
                if(data !== undefined && data !== null && data !== ""){
                    setstatusText(newStatus);
                    showToast(title+" is "+toastStatus);
                }else{
                    showToast(`Before Enable Lead Creation You Must Save The Above Mapping.`,'top-right','error');
                }
            } else{
                if(newStatus === "inactive"){
                    setstatusText(newStatus);
                }else{
                    showToast(`Before Enable Lead Creation You Must Save The Above Mapping.`,'top-right','error');
                }
            }
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const onSave = async (e) => {
        let mappings = [];
        let mappedFields = [];

        if(mappingInfo){
            let maxMappingId = (+mappingIds[mappingIds.length - 1]);

            for(let i=0;i<=maxMappingId;i++){
                if(mappingInfo[i] !== undefined){

                    if(mappedFields.includes(mappingInfo[i].fieldname)){
                        showToast(`Duplicate values not allowed in Field Name. Please choose different option.`,"top-right","error");
                        return;
                    }
                    mappedFields.push(mappingInfo[i].fieldname);
                    mappings.push(mappingInfo[i]);
                }
            }
        }
        let formfilter = "";
        let formids = formInfo[0];
        let entity = "GOOGLEADSPROCESS";
        if(screen === 'CloudTelephony'){
            entity = "CLOUDTELEPHONYLEADSPROCESS";
        } else if(screen === 'webhooks'){
            entity = "WEBHOOKSLEADSPROCESS";
            formids = obj;
            formfilter = formFilOptions.value;
        }
        let params = {
            "ENTITY":entity,
            "OPERATION" : 'UPDATE_FIELD_MAPPING',
            "ID" : formids,
            "fields" : mappings,
            "formfilter" : formfilter,
            "webhookname" : webhookName
        }
        if(screen === 'webhooks'){
           params['mappingneeded'] =  mappingneeded;
        } 
        let response = await requestApi.processServerRequest(params,"WebV2");
        if(response.issuccess){
            if(screen === 'webhooks' && response.data != ""){
                let header = response.data[0];
                let message = response.data[1];
                let isConfirm = await confirmBoxWithImage(header,message,"", "", "", true, "Yes", false, false);
                if(isConfirm){
                    params["skipmandotory"] = true;
                    response = await requestApi.processServerRequest(params,"WebV2");
                }
            }
            if(screen === 'CloudTelephony') {
                if(leadstatus !== "inactive"){
                    changeLeadStatus("Field Mapping","inactive");
                }
                onBackAction();
                showToast(`Saved successfully.`);
            }else if(response.data == ""){
                onBackAction();
                showToast(`Saved successfully.`);
            }
        }else{
            handleErrorResponse(response.errormsg);
        }
    }

    const addField = () => {
        setMappingCount(mappingCount + 1);
        setSuggestions([]);
    }
    const removeField = (removedIndex,variationId) => {
        if(mappingInfo[variationId] != undefined && mandataryFields.includes("#"+mappingInfo[variationId][`fieldselected`]['value']+"#") && screen !== "CloudTelephony"){
            showToast(`This field cannot be removed.`,'top-right','error');
        }else{
            delete mappingInfo[variationId];
            delete mappingIds.splice(removedIndex, 1);
            setMappingCount(mappingCount - 1);
            setMappingIds([...mappingIds]);
            setMappingInfo([...mappingInfo]);
        }
    }
    const fieldempty =  screen === 'CloudTelephony' ? "CloudTelephony Field/ Default value is required." : screen === 'webhooks' && mappingneeded ?  "Webhook Field/ Default value is required." : "Google Ads Field/ Default value is required.";
    let formfilValue = formFilOptions;
    let webhookNames = webhookName;
    const shouldShowForm = (screen !== 'CloudTelephony' && screen !== 'webhooks') || statusText === 'active';
    const shouldHideForm = !mappingneeded && screen === 'webhooks';
    const shouldShowSaveButton = !mappingneeded && screen === 'webhooks';
     for(let i=0;i<mappingCount;i++){

         let mappingId = undefined;
         if(mappingIds[i] !== undefined){
             mappingId = mappingIds[i];
         }else{
             //create new variation id when id not found previously. This will be the last_max_value+1.
             //If there is no variationId found then start from 0.
             if(mappingIds.length > 0){
                 mappingId = (mappingIds[mappingIds.length-1]) + 1;
             }else{
                 mappingId = 0;
             }
             mappingIds[i] = mappingId;
             setMappingIds([...mappingIds]);
         }

         mappingList.push(
             <Fragment>
                 <Row className={'mt-2 mb-3'}>
                     <Col md={"11"}>
                         <Col md={"10"} className={`offset-1`}>
                             <Row className={`google-ads-mapper`}>
                                 <Col md={"4"}>
                                    <Controller
                                         name={`lead_field_${mappingId}`}
                                         control={control}
                                         rules={{ required: (!mappingInfo[mappingId] || (mappingInfo[mappingId] && (mappingInfo[mappingId][`fieldname`] === undefined || mappingInfo[mappingId][`fieldname`] !== undefined && mappingInfo[mappingId][`fieldname`] === ""))) ?`Field name is required.` : false}}
                                         render={({ field }) => {
                                             return (
                                             <Select
                                                 {...field}
                                                 id={`lead_field_${mappingId}`}
                                                 name={`lead_field_${mappingId}`}
                                                 onChange={(e) => {
                                                     onLeadFieldChange(e, "fieldselected",mappingId)
                                                     field.onChange(e);
                                                 }}
                                                 value={
                                                     mappingInfo[mappingId] && mappingInfo[mappingId][`fieldselected`] !== undefined ? mappingInfo[mappingId][`fieldselected`] : {}
                                                 }
                                                 options={fieldsOptions}
                                                 className={`basic-multi-select `}
                                                 classNamePrefix="wa-select"
                                                 menuPlacement={"auto"}
                                                 menuPosition={'fixed'}
                                             />
                                             );
                                         }}
                                     />
                                     {errors[`lead_field_${mappingId}`] && <em className={`error invalid-feedback`}>{errors[`lead_field_${mappingId}`].message}</em>}
                                 </Col>
                                 <Col md={"4"}>
                                     <div className={`googleads-column-name`}>
                                         <Controller
                                             name={`googleads_field_${mappingId}`}
                                             control={control}
                                             rules={{ required: ((!mappingInfo[mappingId] || (mappingInfo[mappingId] && (mappingInfo[mappingId][`defaultvalue`] === undefined || mappingInfo[mappingId][`defaultvalue`] !== undefined && mappingInfo[mappingId][`defaultvalue`] === "")))
                                                 && (!mappingInfo[mappingId] || (mappingInfo[mappingId] && (mappingInfo[mappingId][`googleadsvalue`] === undefined || mappingInfo[mappingId][`googleadsvalue`] !== undefined && mappingInfo[mappingId][`googleadsvalue`] === "")))) ?`${fieldempty}` : false}}
                                             render={({ field }) => {
                                                 return (
                                                 <Select
                                                     {...field}
                                                     id={`googleads_field_${mappingId}`}
                                                     name={`googleads_field_${mappingId}`}
                                                     onChange={(e) => {
                                                         onLeadFieldChange(e, "googleadsfield",mappingId)
                                                         field.onChange(e);
                                                     }}
                                                     value={
                                                         mappingInfo[mappingId] && mappingInfo[mappingId][`googleadsfield`] !== undefined ? mappingInfo[mappingId][`googleadsfield`] : {}
                                                     }
                                                     options={googleAdsFieldOptions}
                                                     className={`basic-multi-select `}
                                                     classNamePrefix="wa-select"
                                                     menuPlacement={"auto"}
                                                     menuPosition={'fixed'}
                                                 />
                                                 );
                                             }}
                                         />
                                         {errors[`googleads_field_${mappingId}`] && <em className={`error invalid-feedback`}>{errors[`googleads_field_${mappingId}`].message}</em>}
                                     </div>
                                 </Col>
                                 <Col md={"4"}>
                                    <div className={`flex`}>
                                        <div style={{ position: 'relative'}}>
                                            <Controller
                                                name={`default_value_${mappingId}`}
                                                control={control}
                                                render={({ field }) => {
                                                    return (
                                                            <input
                                                                {...field}
                                                                type="text"
                                                                name={`default_value_${mappingId}`}
                                                                id="campaign-name"
                                                                placeholder={`Default Value`}
                                                                value={mappingInfo[mappingId] && mappingInfo[mappingId][`defaultvalue`] !== undefined ? mappingInfo[mappingId][`defaultvalue`] : ""}
                                                                autoComplete={"off"}
                                                                onChange={(e) => {
                                                                    onLeadFieldChange(e.target.value, "defaultvalue", mappingId)
                                                                    field.onChange(e);
                                                                }}
                                                                className={'form-control'}
                                                            />
                                                    );
                                                }}
                                            />
                                            {clickedMapId === mappingId && suggestions && (
                                                <ul className={'drop-down-list'} style={{ position: 'absolute', top: 'calc(100% + 5px)', left: 0, width: '100%', margin: 0, padding: 0, zIndex: 9999 }}>
                                                {suggestions.map((suggestion, index) => (
                                                        <li key={index} onClick={(e) => handleSuggestionClick(e.target, "defaultvalue", mappingId)}>
                                                            {suggestion}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                        <ul className="faXMark">
                                            <span className={`input-variation-remove ml-2 ${(screen === 'CloudTelephony' || screen === 'webhooks') && mappingCount == 1 ? "hide" : ""}`}>
                                                <FontAwesomeIcon icon={faXmark} className={`mr-1`} onClick={() => removeField(i, mappingId)} />
                                            </span>
                                        </ul>
                                    </div>
                                </Col>
                             </Row>
                         </Col>
                     </Col>
                 </Row>
             </Fragment>
         );
     }

//notification-status
    return (
        <Fragment>        
            {(screen !== 'CloudTelephony')? 
            <div className="d-flex"> 
                <div className={'cursor-pointer ml-2 mb-2'} onClick={(e) => {onBackAction(e)}}>
                    <FontAwesomeIcon className={`phone-icon`} icon={faArrowLeft}/> Go Back
                </div>
                </div>: ""}
                {(screen === 'CloudTelephony' || screen === 'webhooks') &&
                <div className={``}>
                    {screen === 'CloudTelephony' &&
                      <span className="ctccloudname">Cloud Telephony Mapping</span>
                    }
                    {screen === 'webhooks' && (
                     <div className={`mb-3 formname-column-name offset-1 col-8`}>
                    <Label className={`googleads-column-header pb-2 `} for="webhookUrl">Webhook URL</Label>
                    <div className={`flex`}>
                        <Input value={webhookUrl} className={`google-ads-webhook-url`} disabled={true} />
                        <CopyToClipboard onCopy={copyUrl} text={webhookUrl}>
                            <Button color="success" className={`google-ads-webhook-copy`}>
                                <FontAwesomeIcon icon={faCopy} />
                            </Button>
                        </CopyToClipboard>
                    </div>
                    {copied ? (
                        <FormText color="success">Text has been copied.</FormText>
                    ) : null}
                </div> )}
                {screen != 'webhooks' && (
                  <div className={`leadcreationfont text-end`}>
                      <Switch onColor={"#23ae73"} checked={statusText === "active"} onChange={(status) => changeLeadStatus("Field Mapping",statusText)} />
                       <span className="leadcreationfont">Is Lead Creation Needed </span>
                </div>
                )}
                </div>
                }
                {shouldShowForm && (
            <form  name={'googleads_mapping'} onSubmit={handleSubmit(onSave)}>
                {screen === 'webhooks' && (
                <div className={`formname-column-name`}>
                <Col md={"10"}>
                     <div className={`googleads-column-header`}>{`Webhook Name`}</div>
                 </Col>
                 <Input className={`googleads-column-heade`} md={"10"} 
                 type="text"
                 name="webhook_name"
                 id="webhook_name"
                 autoComplete={'off'}
                 value={ webhookNames != undefined ? webhookNames : ""}   
                 onChange={(e) => {
                     handleWebhookChange(e);
                 }}
                 required />
                <Col md={"10"}>
                     <div className={`googleads-column-header`}>{`Choose a Module`}</div>
                 </Col>
                    <Select 
                        name={`form_name_filter`}
                        id={`form_name_filter`}
                        className={`basic-multi-select `}
                        classNamePrefix="wa-select"
                        menuPlacement={"auto"}
                        menuPosition={'fixed'}
                        onChange={(e) => {
                          onFormnameChange(e)
                        }} 
                        value={formfilValue != undefined ? formfilValue : ""}
                        options={formFilterOptions}
                    />   
                </div>  
               )}
                {shouldShowForm && !shouldHideForm && ( 
                    Object.keys(mappingList).length > 0 && (
                        <div className={`pl-2 pt-2 pb-2 mb-3 mt-3 googleads-mapping-wrapper  ${screen === 'webhooks' ? "webhooks-mapping-wrapper" : "" }`}>
                            <Row className={'mt-2 mb-3'}>
                                <Col md={"11"}>
                                    <Col md={"10"} className={`offset-1`}>
                                        <Row>
                                            <Col md={"4"}>
                                                <div className={`googleads-column-header`}>{`Field Name`}<CratioTooltip id={"webhook_field1"} title={"The mandatory fields will be listed by default only for the first time."} content={<FontAwesomeIcon className={`${screen === 'webhooks' ? 'info-icon' : 'hide'}`} icon={faCircleInfo}/>} /></div>
                                            </Col>
                                            <Col md={"4"}>
                                                <div className={`googleads-column-header`}>{screen === 'Googleads' ? `Google Ads Field`  : screen === 'CloudTelephony' ? `Cloud TelePhony Fields` : `Webhook Fields`}</div>
                                            </Col>
                                            <Col md={"4"}>
                                                <div className={`googleads-column-header`}>{`Default Value`}</div>
                                            </Col>
                                        </Row>
                                    </Col>
                                </Col>
                            </Row>

                            {mappingList.map((column) => {
                                return column;
                            })}
                            <Row className={'mt-2 mb-3'}>
                                <Col md={'11'} className={`custom-pr-2`}>
                                    <Col md={'10'} className={`offset-9`}>
                                        <div className={`add-autoreply-intent mt-3`} onClick={addField} >
                                            <FontAwesomeIcon icon={faPlus} className={`mr-1`}/>
                                            Add New Field
                                        </div>
                                    </Col>
                                </Col>
                            </Row>
                        </div>
                    )
                )}
                <div className={`text-center webhooksave ${shouldShowSaveButton ? ' mt-5': ""}`}>
                    <Button  type={'submit'} className={cx("btn-icon le-button lePrimaryBtn")}>
                        {`${shouldShowSaveButton ? 'Save' : 'Save Mapping'}`}
                    </Button>
                </div>
            </form> )}
            
        </Fragment>
    );
}

export default FieldsMapping;